module.exports = __webpack_public_path__ + "img/8stars.4a943384.jpg";